import { useToggle } from './useToggle';

export function useHover(): [boolean, { onMouseEnter: () => void; onMouseLeave: () => void }] {
    const [hovered, { on: onMouseEnter, off: onMouseLeave }] = useToggle(false);
    return [hovered, { onMouseEnter, onMouseLeave }];
}
